import { useContext } from "react";

import { SettingsContext } from "@hubcapp/context";

const useSettings = () => {
  const context = useContext(SettingsContext);

  return context;
};

export default useSettings;
